import helperLocalStorage   from 'shared/mixins/helper-localstorage';

/**
 * @module
 */
 
const selector = '[data-js-form-saving]';
const formSaving = function(el, app) {
  
  const localStorageHelper = helperLocalStorage(app);
  const $el = $(el);
  const storageKey = app.cookiePrefix + '-form-save-' +  ( $el.attr('data-js-form-saving') || $el.attr('name') );
  
  const init = function() {
    registerEvents();
  };
  
  const registerEvents = function() {
    const inputType = $el.attr('type');
    if ((inputType === 'radio' || inputType === 'checkbox')) {
      $el.on('change', updateStorage);
    } else {
      $el.on('keyup blur change', updateStorage);
    }
  };
  
  const updateStorage = function(ev) {
    const inputType = $el.attr('type');
    const inputValue = $el.val();
    if ((inputType === 'radio' || inputType === 'checkbox') && $el.prop('checked')) {
      localStorageHelper.set(storageKey, inputValue, true);
    } else if ((inputType === 'radio' || inputType === 'checkbox') && !$el.prop('checked')) {
      localStorageHelper.remove(storageKey, inputValue, true);
    } else {
      localStorageHelper.set(storageKey, inputValue, true);
    }
  };

  return {
    init: init()
  };
};

formSaving.selector = selector;

export default formSaving;
